var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndustrials = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#576F8D",
    fillRule: "evenodd",
    d: "m23.903 17.114-4.924 2.852v-2.852l-4.928 2.852v-2.852l-5.236 2.997.033 4.718q.594.489 1.25.891.85.538 1.784.912l-.025-4.284h3.125l.02 5.089q.69.084 1.383.082a11.85 11.85 0 0 0 6.289-1.79 12 12 0 0 0 1.254-.892z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#576F8D",
    fillRule: "evenodd",
    d: "m21.45 18.249-1.233.655-1.3.688v-2.63l-.384.203-1.295.688.135-2.968h3.93zM21.203 13.646h-3.717l.082-1.734h3.552zM16.247 18.41l-1.2.633-1.04.549V17.05l-1.724.907.209-4.559h3.526zM20.121 10.413a1.84 1.84 0 0 1-1.502.788c-.055 0-.11 0-.166-.01a1.73 1.73 0 0 1-1.046-.475.41.41 0 0 0-.528-.042 1.9 1.9 0 0 1-1.056.357 1.437 1.437 0 0 1-1.015-.397.38.38 0 0 0-.268-.112h-.017a.42.42 0 0 0-.277.119c-.33.321-.716.578-1.14.758-.401.165-.83.255-1.264.265q-.118 0-.237-.013c-.046 0-.089-.013-.131-.017a1 1 0 0 1-.141-.018.7.7 0 0 1-.137-.025 4 4 0 0 1-.568-.162 1 1 0 0 1-.08-.035 2 2 0 0 1-.253-.119 1 1 0 0 1-.102-.056l-.034-.017s-.008 0-.013-.008q-.143-.083-.273-.171l-.05-.04h-.01a3 3 0 0 1-.29-.237 3.59 3.59 0 0 1-.763-4.41c.644-1.179 1.788-1.733 3.171-1.857h.013A3.55 3.55 0 0 1 14.6 5.727q.064.068.118.142.02.015.03.038.062.088.119.188.149.241.25.506a.4.4 0 0 0 .061.107.3.3 0 0 0 .047.047.4.4 0 0 0 .277.12.4.4 0 0 0 .163-.035c.229-.106.478-.161.73-.163a1.47 1.47 0 0 1 1.268.695l.747.154h.009q.127-.018.256-.018a1.76 1.76 0 0 1 1.288.57 1.86 1.86 0 0 1 .16 2.335",
    clipRule: "evenodd"
  })));
};
export default SvgIndustrials;